<mat-toolbar color="accent">
  <div class="flex flex-1 items-center justify-between">
    <span>ACC Claim Lodgement</span>

    <div class="flex items-center gap-4">
      @if (data.testMode) {
        <button mat-flat-button color="primary" (click)="submitTestClaim()">
          Test Claim
        </button>
      }
      <button mat-flat-button (click)="onCloseRequested()">Close</button>
    </div>
  </div>
</mat-toolbar>

<mat-dialog-content class="h-[80vh] overflow-hidden p-0">
  <pr-acc-claim-lodgement-form
    #formComponent
    [patient]="data.patient"
    [claim]="data.claim"
    [initialStep]="data.accPatientFormType"
    [testMode]="data.testMode"
    (claimSubmit)="onSubmit($event)"
    (closeRequested)="onCloseRequested()"
  />
</mat-dialog-content>
